// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"c6d9c39d","227":"96a8b48f","469":"eae7a51d","735":"5cff111c","785":"ea256184"}[chunkId] + ".js";
};